
        var result = require("!!../../../../../node_modules/css-loader/index.js!./case-detail.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cases-management/case-detail/case-detail.component.css
// module id = 603
// module chunks = 0